<template>
    <div>
        <div>
            <el-form ref="form" :model="form" :rules="rules" label-width="7em" class="baseInfoForm">
                <el-form-item label="附件名称" prop="name">
                    <el-input
                            v-model="form.name"
                            placeholder="请输入附件名称"
                            maxlength="30">
                    </el-input>
                </el-form-item>
                <el-form-item label="附件文件" :required="true">
                    <div class="uploaderDiv">
                        <uploader ref="uploader" :options="uploaderOptions" @file-added="fileAdded"
                                  @file-success="handleUploadSuccess">
                            <uploader-unsupport></uploader-unsupport>
                            <div class="uploader-files">
                                <div>
                                    <div v-if="fileIsNotExit">
                                        <uploader-btn :attrs="attrs" class="el-button el-button--default is-plain">
                                            <i class="el-icon-circle-plus-outline"></i>上传附件
                                        </uploader-btn>
                                    </div>
                                    <div v-else>
                                        <el-button round plain disabled>已上传</el-button>
                                    </div>
                                </div>
                                <div class="uploadTxt">支持JPG、PNG、PDF、DOCX、DOC、RAR、ZIP格式文件上传，文件大小不超50MB</div>
                                <slot :files="files">
                                    <ul>
                                        <li v-for="(file,i) in files" :key="file.id">
                                            <span >
                                                <i class="el-icon-document"></i> {{file.name}}
                                                <el-button type="text" icon="el-icon-delete" @click="deleteUploaderFile(i)">删除</el-button>
                                            </span>
                                        </li>
                                    </ul>
                                </slot>

                                <!--<div v-if="files">-->
                                    <!--<el-button>已上传</el-button>-->
                                <!--</div>-->
                            </div>
                        </uploader>
                    </div>

                    <!--<input type="hidden" v-model="form.attachment">-->

                    <div v-if="form.file">
                        <span>
                            <i class="el-icon-document"></i> {{fileName(form.file)}}
                        </span>
                        <el-button type="text" icon="el-icon-delete" @click="deleteFile()">删除</el-button>
                    </div>
                </el-form-item>
                <el-form-item label="附件描述" prop="description">
                    <el-input
                            type="textarea"
                            v-model="form.description"
                            placeholder="简短描述一下文件内容，注意不要泄露个人隐私，如手机号、QQ、微信、家庭住址等"
                            maxlength="800"
                            show-word-limit>
                    </el-input>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="updateAttachment()" v-if="editStatus.status==true">更新保存
                    </el-button>
                    <el-button type="primary" @click="saveAttachment()" v-else>保存</el-button>
                    <el-popconfirm title="确认取消编辑？"
                        @confirm="cancel()"
                        placement="top-start"
                        icon="el-icon-info"
                        icon-color="red"
                        class="ml10">
                        <el-button slot="reference">取消</el-button>
                    </el-popconfirm>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
    import {mergeFile} from '@/api/file';
    import {saveAttachment, updateAttachment} from '@/api/resume';

    export default {
        name: 'attachment',
        props: ['form', 'resumeId', 'editStatus'],
        data() {
            return {
                rules: {
                    name: [
                        {required: true, message: '请输入附件名称'},
                        {pattern: /^\S+$/, message: '支持输入中英文、数字和特殊字符'},
                        {max: 30, message: '字符长度不超过30'}
                    ],
                    description: [
                        {pattern: /^\S+$/, message: '支持输入中英文、数字和特殊字符'},
                        {max: 800, message: '字符长度不超过800'}
                    ]
                },
                // uploader组件文件上传参数
                uploaderOptions: {
                    target: '/api/file/chunk',
                    chunkSize: '1048576',
                    testChunks: true,
                    checkChunkUploadedByResponse: this.checkChunkUploadedByResponse,
                },
                // uploader组件上传证书附件文件类型限制
                attrs: {
                    accept: '.jpg, .png, .pdf, .docx, .doc, .rar, .zip'
                },
                // uploader组件文件上传校验
                validateFile: {
                    accept: '.jpg, .png, .pdf, .docx, .doc, .rar, .zip',
                    limit: 1,
                    totalSize: 50,
                    tip: '可上传1个文件，总大小不超过10MB'
                },
                // 附件文件上传对象
                files: {},
            }
        },
        computed: {
            fileIsNotExit(){
                return JSON.stringify(this.files) == "{}" && !this.form.file;
            },
            // 截取文件名
            fileName(){
                return function(file){
                    if (file!=null) {
                        return file.substring(file.lastIndexOf("/")+1, file.length);
                    }
                }
            },
        },
        methods: {
            saveAttachment() {
                this.$refs["form"].validate(valid => {
                    if (valid) {
                        this.form.resumeId = this.resumeId;
                        if (this.form.fileId == null || this.form.fileId == undefined || this.form.fileId == '') {
                            this.$message.error("请上传附件");
                            return;
                        }
                        saveAttachment(this.form).then(res => {
                            this.cancel();
                            this.$store.commit('changeResumeRefreshFlag', true);
                        }).catch(() => {
                            this.$message.error("简历附件保存失败");
                        });
                    }
                })
            },
            updateAttachment() {
                this.$refs["form"].validate(valid => {
                    if (valid) {
                        this.form.resumeId = this.resumeId;
                        if (this.form.file == null || this.form.file == undefined || this.form.file == '') {
                            if (this.form.fileId == null || this.form.fileId == undefined || this.form.fileId == '') {
                                this.$message.error("请上传附件");
                                return;
                            }
                        }
                        updateAttachment(this.form).then(res => {
                            this.cancel();
                            this.$store.commit('changeResumeRefreshFlag', true);
                        }).catch(() => {
                            this.$message.error("简历附件保存失败");
                        });
                    }
                })
            },


            // 简历附件表单取消编辑状态
            cancel() {
                this.editStatus.id = 0;
                this.editStatus.status = false;
                this.$emit('editStatus', this.editStatus);
                this.$store.commit('changeResumeEditStatus', false);
                this.$store.commit('changeAttachmentEditStatus', false);
            },


            deleteUploaderFile(i) {
                this.files.splice(i, 1);
                this.form.fileId = null;
                this.files = {};
            },
            deleteFile() {
                this.form.file = null;
            },
            validateFilename(filename) {
                return /^[\u4e00-\u9fa5a-zA-Z0-9-_.]{1,20}$/.test(filename);
            },
            fileAdded(file) {
                let time = new Date().getTime();
                file.name = time + file.name.substring(file.name.indexOf("."));
                file.uniqueIdentifier = time;
                const uploader = this.$refs.uploader.uploader;
                const limit = this.validateFile.limit;
                const maxSize = 1024 * 1024 * this.validateFile.totalSize;
                const accept = this.validateFile.accept;

                const already = uploader.files.find(x => x.name === file.name);
                if (already) {
                    file.ignored = true;
                    this.$message.error('请不要重复上传相同文件');
                    file.cancel()
                    return;
                }
                if (accept.indexOf(file.name.substring(file.name.lastIndexOf('.'))) === -1) {
                    file.ignored = true;
                    this.$message.error(`文件格式不符合要求，请上传${accept}格式文件`);
                    return;
                }
                if (uploader.files.length >= limit) {
                    file.ignored = true;
                    this.$message.error(`上传的文件总数不能大于${limit}`);
                    return;
                }
                if (file.size > maxSize) {
                    file.ignored = true;
                    this.$message.error(`文件过大请重新上传`);
                    return;
                }
            },
            /** 分块文件上传*/
            checkChunkUploadedByResponse(chunk, message) {
                let res = JSON.parse(message);
                if (Array.isArray(res.data)) {
                    let chunkNumbers = res.data;
                    return (chunkNumbers || []).indexOf(chunk.offset + 1) >= 0;
                } else {
                    if (null === res.data) {
                        return false;
                    } else {
                        chunk.file.itemId = res.data;
                        return true;
                    }
                }
            },
            /** 分块文件上传完毕，合并分块文件，返回文件id*/
            async handleUploadSuccess(rootFile, file, message, chunk) {
                let res = JSON.parse(message);
                if (res.data && res.data === true) {
                    console.log('分块上传完成，开始合并...')
                    mergeFile(file).then((res) => {
                        console.log("文件合并完成");
                        this.form.fileId = res.data.fileId;
                        this.files = this.$refs.uploader.files;
                    }).catch(() => {

                    })
                }
            },
        }

    }
</script>